import React from 'react'
import PropTypes from 'prop-types'
import update from 'immutability-helper'
import Modal from 'react-modal'

import { run, RuleRunner } from 'Pods/Shared/RuleRunner'
import { required } from 'Pods/Shared/Rules/Rules'
import Icon from 'Pods/Shared/Icon/Icon'
import InputFieldWithPrefix from 'Pods/Shared/InputFieldWithPrefix'

let fieldValidations = [RuleRunner('url', 'Link', required)]

class AddEmbedModal extends React.Component {
  constructor() {
    super()

    this.state = {
      url: '',
      showErrors: false,
    }

    this.handleInputChange = this.handleInputChange.bind(this)
    this.errorFor = this.errorFor.bind(this)
    this.handleUrlSubmit = this.handleUrlSubmit.bind(this)
    this.checkUrl = this.checkUrl.bind(this)
  }

  componentWillMount() {
    fieldValidations.push(RuleRunner('url', 'Link', this.checkUrl))
    this.setState({ validationErrors: run(this.state, fieldValidations) })
  }

  componentWillUnmount() {
    fieldValidations = []
  }

  componentDidUpdate(prevProps) {
    if (this.props.modalIsOpen !== prevProps.modalIsOpen && this.props.modalIsOpen) {
      this.setState({ validationErrors: run(this.state, fieldValidations) })
    }
  }

  handleInputChange(e) {
    const newState = update(this.state, { [e.target.id]: { $set: e.target.value } })
    newState.validationErrors = run(newState, fieldValidations)

    this.setState(newState)
  }

  errorFor(field) {
    return this.state.validationErrors[field] || ''
  }

  checkUrl(value) {
    const videoId = this[`parse${this.props.embedTitle}Url`](value)
    if (videoId) {
      return null
    }
    return fieldName => `Please enter valid ${this.props.embedTitle} url`
  }

  parseYoutubeUrl(value) {
    if (/youtube./.test(value) && /\?v=/.test(value)) {
      return value.split(/\?v=/).pop()
    }
    if (/youtu.be/.test(value)) {
      return value.split(/youtu.be\//).pop()
    }
    return null
  }

  parseVimeoUrl(value) {
    if (/vimeo.com/.test(value)) {
      return (value.match(/\d+/g) || []).shift()
    }
    return null
  }

  handleUrlSubmit() {
    const errorsArr = Object.getOwnPropertyNames(this.state.validationErrors)

    this.setState({ showErrors: true })

    if (errorsArr.length === 0) {
      this.props.addEmbed(this.state.url)
    } else {
      return null
    }
  }

  render() {
    return (
      <Modal
        isOpen={this.props.modalIsOpen}
        shouldCloseOnOverlayClick
        onRequestClose={this.props.closeModal}
        contentLabel="Modal"
        ariaHideApp={false}
        className={{
          base: '',
          afterOpen: 'overlay-modal--container_after-open overlay-modal-container--smaller',
          beforeClose: 'overlay-modal--container_before-close',
        }}
        overlayClassName={{
          base: 'overlay-modal--background',
          afterOpen: 'overlay-modal--background_after-open',
          beforeClose: 'overlay-modal--background_before-close',
        }}
      >
        <div className="overlay-modal">
          <button className="btn btn-transparent overlay-modal--close-inner" onClick={this.props.closeModal}>
            <Icon type={['fal', 'times']} color="grey-dark" />
          </button>
          <div className="overlay-modal--content overlay-modal--add-embed">
            <div className="l-inner-large">
              <div className="heading-20 modal-header">Add {this.props.embedTitle} preview</div>
              <p className="text-default u-mb10">
                Please copy and paste <span className="text-semibold">{this.props.embedTitle}</span> URL in the field below
              </p>

              <InputFieldWithPrefix
                id="url"
                name="url"
                prefix={<Icon type={['fal', 'link']} notSpaced />}
                simpleError
                placeholder="Paste link here"
                errorText={this.errorFor('url')}
                showError={this.state.showErrors}
                value={this.state.url}
                formClassName="form-group-grey"
                inputClassName="form-control-grey"
                onChange={this.handleInputChange}
              />

              <div className="u-text-right">
                <button type="button" className="btn btn-outline-default btn-fat u-mr10" onClick={this.props.closeModal}>
                  Cancel
                </button>
                <button type="button" className="btn btn-primary btn-fat" onClick={this.handleUrlSubmit}>
                  Add preview
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

AddEmbedModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  embedTitle: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  addEmbed: PropTypes.func.isRequired,
}

export default AddEmbedModal
